var $acd72b88f580fe64$exports = {};
$acd72b88f580fe64$exports = {
    "(optional)": `(iste\u{11F}e ba\u{11F}l\u{131})`,
    "(required)": `(gerekli)`
};


export {$acd72b88f580fe64$exports as default};
//# sourceMappingURL=tr-TR.module.js.map
